import type { FunctionComponent } from "react"

import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { COMPANY_PAGE_TYPE } from "@/modules/companies/client/api/endpoints/company"
import { ArticlesEmptyStates } from "@/modules/companies/client/components/ArticlesEmptyStates/ArticlesEmptyStates"
import { ArticlesFilters } from "@/modules/companies/client/components/ArticlesFilters/ArticlesFilters"
import { ArticleListing } from "@/modules/companies/client/components/ArticlesListing/ArticleListing"
import { ArticlesLoading } from "@/modules/companies/client/components/ArticlesListing/ArticlesLoading"
import { ArticlesTitle } from "@/modules/companies/client/components/ArticlesTitle/ArticlesTitle"
import { EventListing } from "@/modules/companies/client/components/EventsListing/EventListing"
import { EventsTitle } from "@/modules/companies/client/components/EventsTitle/EventsTitle"
import { useArticlesHasFilter } from "@/modules/companies/client/hooks/useArticlesHasFilter"
import { useCompanyArticlesFetch } from "@/modules/companies/client/hooks/useCompanyArticlesFetch"
import { useCompanyEventsFetch } from "@/modules/companies/client/hooks/useCompanyEventsFetch"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

export const NewsFeedWrapper: FunctionComponent = () => {
  const { dataCompany } = useCompanyFetch()
  const { dataCompanyEvents, isErrorCompanyEvents } = useCompanyEventsFetch()
  const { dataCompanyArticles, isLoadingCompanyArticles, isSuccessCompanyArticles } = useCompanyArticlesFetch()
  const hasFilters = useArticlesHasFilter()

  const showEvents = !isErrorCompanyEvents && !!dataCompanyEvents && dataCompanyEvents.events.length > 0
  const showLoadingArticles = isLoadingCompanyArticles
  const showArticles =
    !isLoadingCompanyArticles &&
    isSuccessCompanyArticles &&
    dataCompanyArticles &&
    dataCompanyArticles?.articles.length > 0
  const showArticlesEmptyStates =
    !isLoadingCompanyArticles &&
    isSuccessCompanyArticles &&
    dataCompanyArticles &&
    dataCompanyArticles?.articles.length === 0
  const showArticlesFilters = dataCompany?.pageType === COMPANY_PAGE_TYPE.STANDARD ? false : showArticles || hasFilters

  return (
    <>
      {showEvents && (
        <Layout hasBottomPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
          <Layout.Column>
            <EventsTitle />
            <EventListing />
          </Layout.Column>
        </Layout>
      )}
      <Layout colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
        <Layout.Column>
          <ArticlesTitle />
          {showArticlesFilters && <ArticlesFilters />}
          {showLoadingArticles && <ArticlesLoading />}
          {showArticles && <ArticleListing />}
          {showArticlesEmptyStates && <ArticlesEmptyStates />}
        </Layout.Column>
      </Layout>
    </>
  )
}
